module.exports = __webpack_public_path__ + "media/images/badges/stride-badge-205f974a2dbaf5413f323418a95c3904.svg";